<template>
  <div class="smart-minutes">
    <!-- sidenav -->
    <sidenav
      :custom-class="'bg-white'"
      :class="['position-fixed', 'fixed-start']"
      :style="{ zIndex: this.$store.state.isSidenavOpen ? 100 : '' }"
      :chatbots="chatbots"
      :isDeleteMode="isDeleteMode"
      @bot-init="handleInitChat"
      @bot-selected="getConversationHistory"
      @bot-deleted="handleConfirmDeleteBot"
      @handle-delete-mode="handleDeleteMode"
    >
    </sidenav>
    <div class="container-fluid py-4">
      <div class="mt-5">
        <transition name="fade" mode="out-in">
          <default-card
            v-if="isDefaultCard"
            key="default"
            :model="selectedModel"
            :modelLabel="selectedModelLabel"
            :modelOptions="selectedModelOptions"
            @handle-selected-model="handleSelectedModel"
            @handle-selected-model-label="handleSelectedModelLabel"
            @file-added="handleFileUpload"
          />
          <chat-card
            v-else
            key="chat"
            :messages="messages"
            :model="selectedModel"
            :modelLabel="selectedModelLabel"
            :modelOptions="selectedModelOptions"
            :transcriptionResult="transcriptionResult"
            :is-history-loaded="isHistoryLoaded"
            :parse-markdown="parseMarkdown"
            :is-streaming="isStreaming"
            @stop-stream="stopStreaming"
            @click-cleansing="handleCleansing"
            @click-summary="handleSummary"
            @click-minutes="handleMinutes"
            @handle-office-file-download="handleOfficeFileDownload"
            @handle-selected-model="handleSelectedModel"
            @handle-selected-model-label="handleSelectedModelLabel"
            @send-message="handleSendMessage"
          />
        </transition>
      </div>
    </div>
  </div>
  <!-- Overlay for processing message -->
  <ProcessingOverlay :show="isProcessing" />
  <ErrorPopup
    :show="showErrorPopup"
    :message="errorMessage"
    @close="closeErrorPopup"
  />
  <ConfirmDeleteBotPopup
    :show="showConfirmDeleteBotPopup"
    @close="closeConfirmDeleteBotPopup"
    @delete="deleteChatbot"
  />
</template>

<script>
import HTTPService from '@/services/HTTPService.js'
//import StorageService from '@/services/StorageService.js'
import DOMPurify from 'isomorphic-dompurify'
//import {cilCopy, cilPaperclip, cilSend, cilX} from '@coreui/icons'
import NotoSansJp from '@/fonts/NotoSansJP-VariableFont_wght.ttf'
import { NAV_MASTER } from '@/constants/navMaster'
import Sidenav from '../MainChat/components/Sidenav/Index.vue'
import ChatCard from './components/ChatCard.vue'
import DefaultCard from './components/DefaultCard.vue'
import ProcessingOverlay from '@/components/ProcessingOverlay.vue'
import ErrorPopup from '@/components/ErrorPopup.vue'
import { v4 as uuidv4 } from 'uuid'
import ConfirmDeleteBotPopup from '@/components/ConfirmDeleteBotPopup.vue'
import { useAuthStore } from '@/store/auth'

export default {
  components: {
    ConfirmDeleteBotPopup,
    ErrorPopup,
    ProcessingOverlay,
    Sidenav,
    ChatCard,
    DefaultCard,
  },
  data() {
    return {
      //cilSend,
      //cilPaperclip,
      //cilX,
      //cilCopy,
      selectedModel: 'claude-haiku-5-5',
      selectedModelLabel: 'claude-haiku-5-5', // Default model
      selectedModelOptions: [
        { value: 'claude-sonnet-5-5', label: 'claude-sonnet-5-5' },
        { value: 'claude-haiku-5-5', label: 'claude-haiku-5-5' },
      ],
      messages: [],
      userInput: '',
      messageIndex: 0,
      conversationId: '',
      attachedFiles: [],
      isPromptCollapsed: false,
      promptLabelText: '追加コンテキスト',
      promptValue: '',
      transcriptionResult: '',
      summarizeResult: '',
      bot_id: '',
      delete_bot_id: '',
      botName: '議事録っチャオ',
      isCreatingChatbot: false,
      isUpdatingChatbot: false,
      errorMessage: '',
      showErrorPopup: false,
      showConfirmDeleteBotPopup: false,
      planerror: false,
      isSummarizing: false,
      isDefaultCard: true,
      isProcessing: false,
      isUserInput: false,
      maxPerFileMB: 850,
      chatbots: [],
      isHistoryLoaded: false,
      abortController: null,
      isStreaming: false,
      isDeleteMode: false,
    }
  },
  async mounted() {
    try {
      console.log('get user..')

      await this.getChatbots()
      if (this.chatbots.length >= 50) {
        await this.getConversationHistory(this.chatbots[0].id)
      }
    } catch (error) {
      console.error(error)
      // If there's an error or no user found, redirect to the login page
      this.$router.push('/login')
    }

    if (!this.conversationId) {
      this.conversationId = uuidv4()
    } else {
      this.startConversation()
    }
  },
  computed: {
    getPromptLabel() {
      return this.promptLabelText
    },
  },
  methods: {
    stopStreaming() {
      if (this.abortController) {
        this.abortController.abort()
        this.abortController = null
      }

      this.isStreaming = false
    },
    handleInitChat() {
      this.isDefaultCard = true
      this.bot_id = ''
      this.summarizeResult = ''
      this.transcriptionResult = ''
      this.conversationId = uuidv4()
      this.messages = []
    },
    onModelChange() {
      console.log('Selected model:', this.selectedModel)
    },

    async handleOfficeFileDownload(messageId, type) {
      this.isProcessing = true
      const response = await HTTPService.office_file_download(messageId, type)

      if (response && response.status === 401) {
        localStorage.setItem('expired', 'true')
        window.location.href = '/login'
        return
      }

      const data = response.data
      await HTTPService.fetchAndDownload(data.s3_url, data.filename)
      await HTTPService.delete_office_file(data.filepath)

      this.isProcessing = false
    },

    //handleFileUpload(event) {
    async handleFileUpload(file) {
      const fileSizeMB = file.size / (1024 * 1024) // MB換算
      if (fileSizeMB > this.maxPerFileMB) {
        this.errorMessage = `・「${file.name}」はサイズが大きすぎます。\r\n・アップロードは１ファイル最大 ${this.maxPerFileMB}MBまでとなります。\r\n・ファイルを圧縮するか、分割してお試しください。`
        this.showErrorPopup = true
        return
      }

      this.attachedFiles = []
      this.attachedFiles.push(file)
      this.promptValue = '文字起こしをしてください。'
      this.userInput = ''
      this.isProcessing = true

      if (this.attachedFiles[0]) {
        const allowedTypes = [
          'audio/mp3',
          'audio/wav',
          'audio/flac',
          'audio/m4a',
          'audio/x-m4a',
          'video/mp4',
          'video/avi',
          'video/quicktime',
          'video/webm',
          'video/mpeg',
          'audio/mpeg',
          'audio/mpga',
          'video/x-matroska',
        ]
        if (allowedTypes.includes(this.attachedFiles[0].type)) {
          // 文字起こしを実行
          await this.transcibeAudio()
          // チャットボットIDを発行
          this.botName = `${file.name}`
          await this.createChatbot()
          // チャットデータを保存
          this.isUserInput = false
          await this.summarizeText('file')

          window.gtag('event', 'API', {
            event_name: '議事録っチャオ',
            action: 'ファイルアップロード',
            model: this.selectedModelLabel,
            id: this.$store.state.userId,
          })
          //await this.summarizeText('file')
        } else {
          this.errorMessage =
            '・ファイルの読み込むことができませんでした。\r\n' +
            '・以下のファイル形式に対応しています。\r\n' +
            '「mp3, wav, flac, m4a, mp4, avi, webm, mpeg, mpga, mov」'
          this.showErrorPopup = true
          this.isProcessing = false
        }
      }
    },

    handleCleansing() {
      this.promptValue =
        'あなたは、音声認識技術により自動で文字起こしされた\n' +
        '会議・スピーチの発言記録を【修正・整形】するAIです。\n' +
        '内容の意味を一切変えず、可読性のみを改善してください。\n' +
        '\n' +
        '見出しには ChatGPT のようなアイコンを付加してください。\n' +
        '\n' +
        '# システムの役割\n' +
        'あなたはプロフェッショナルな文字起こし補正アシスタントです。\n' +
        '提供された「会議の文字起こしテキスト」をもとに、\n' +
        '次の【ルール】を厳守して修正結果のみを出力してください。\n' +
        '\n' +
        '# 【最重要ルール】\n' +
        '1. **内容保持**\n' +
        '   - 元の発言内容は一切削除・要約・省略しないでください\n' +
        '   - 情報の追加・推測・再構成は禁止です\n' +
        '\n' +
        '2. **削除してよいもの（完全削除）**\n' +
        '   - 以下のフィラーワード・口癖のみ削除してください  \n' +
        '     「えー」「えっと」「あの」「その」「まあ」「なんか」\n' +
        '     「～ですね」「はい」「ええ」\n' +
        '\n' +
        '3. **修正してよいもの**\n' +
        '   - 明らかな誤字・脱字\n' +
        '   - 音声認識由来の誤変換\n' +
        '   - 話し言葉特有で意味が不明瞭な表現\n' +
        '   ※ただし **意味・ニュアンスは絶対に変更しないこと**\n' +
        '\n' +
        '4. **文章整形**\n' +
        '   - 文が長すぎる場合は、句点（。）や読点（、）を補って読みやすくしてください\n' +
        '   - 箇条書き化・並び替え・文順変更は禁止です\n' +
        '\n' +
        '5. **話者の意図保持**\n' +
        '   - 発言者の意図・トーン・責任範囲を変えないよう最大限注意してください\n' +
        '\n' +
        '# 役割と参照ルール\n' +
        '- user ロールに含まれる長文は、必ず【背景情報】として扱ってください。\n' +
        '- 背景情報の要約・言い換え・引用・補足説明・内容への言及は禁止です。\n' +
        '- 回答すべき対象は、下記で明示されている【質問】のみです。\n' +
        '- 前置き・注意書き・補足説明・結論以外の文章を出力してはいけません。\n' +
        '\n' +
        '## 出力言語判定ルール（最優先・絶対厳守）\n' +
        '- 出力言語は、この system プロンプトの言語では決定してはいけません。\n' +
        '- 必ず user ロールの content 全体のみを解析して決定してください。\n' +
        '\n' +
        '### 言語選択ルール\n' +
        '- 英語の文章量（文字数・語数）が約50%以上 → 英語で回答\n' +
        '- 日本語の文章量（文字数・語数）が約50%以上 → 日本語で回答\n' +
        '- 明確な差がない場合 → user ロール content の先頭文の言語を採用\n' +
        '\n' +
        '### 厳守事項\n' +
        '- この言語判定ルールは、質問文の言語より常に優先されます。\n' +
        '- 翻訳は行ってはいけません。\n' +
        '- 判定された言語以外で回答してはいけません。\n' +
        '\n' +
        '# 出力条件\n' +
        '- 修正後のテキストのみを出力してください\n' +
        '- 前置き・説明・注釈・まとめは禁止です\n' +
        '\n' +
        '## 入力（言語非依存）\n' +
        '{user_input_translated}'

      //this.userInput = this.transcriptionResult
      this.userInput = 'フィラーワードの削除、誤字脱字の修正を行ってください。'
      //this.isDefaultCard = false
      this.isUserInput = false
      this.summarizeText('input')

      window.gtag('event', 'API', {
        event_name: '議事録っチャオ',
        action: '文字起こしのクレンジング',
        model: this.selectedModelLabel,
        id: this.$store.state.userId,
      })
    },

    handleSummary() {
      this.promptValue =
        'あなたは、音声認識技術により自動で文字起こしされた会議・スピーチ・対話ログを要約するAIです。\n' +
        '\n' +
        '## 役割と参照ルール\n' +
        '- user ロールに含まれる長文は、必ず【背景情報】として扱ってください。\n' +
        '- 背景情報の要約・言い換え・引用・補足説明・内容への言及は禁止です。\n' +
        '- 回答すべき対象は、下記で明示されている【質問】のみです。\n' +
        '- 前置き・注意書き・補足説明・結論以外の文章を出力してはいけません。\n' +
        '\n' +
        '## 出力言語判定ルール（最優先・絶対厳守）\n' +
        '- 出力言語は、この system プロンプトの言語では決定してはいけません。\n' +
        '- 必ず user ロールの content 全体のみを解析して決定してください。\n' +
        '\n' +
        '### 言語選択ルール\n' +
        '- 英語の文章量（文字数・語数）が約50%以上 → 英語で回答\n' +
        '- 日本語の文章量（文字数・語数）が約50%以上 → 日本語で回答\n' +
        '- 明確な差がない場合 → user ロール content の先頭文の言語を採用\n' +
        '\n' +
        '### 厳守事項\n' +
        '- この言語判定ルールは、質問文の言語より常に優先されます。\n' +
        '- 翻訳は行ってはいけません。\n' +
        '- 判定された言語以外で回答してはいけません。\n' +
        '\n' +
        '## 質問（言語非依存）\n' +
        '{user_input_translated}'

      //this.userInput = this.transcriptionResult
      this.userInput = '文章を要約してください。'
      //this.isDefaultCard = false
      this.isUserInput = false
      this.summarizeText('input')

      window.gtag('event', 'API', {
        event_name: '議事録っチャオ',
        action: '文章を要約',
        model: this.selectedModelLabel,
        id: this.$store.state.userId,
      })
    },

    handleMinutes() {
      this.promptValue =
        'あなたは、音声認識技術により自動で文字起こしされた会議の発言記録を整理し、議事録を作成するAIです。\n' +
        '見出しには、ChatGPT のように視認性の高いアイコン表現を付加してください。\n' +
        '\n' +
        '# システムの役割\n' +
        'あなたはプロフェッショナルな議事録作成アシスタントです。\n' +
        '提供された「会議の文字起こしテキスト」を分析し、以下のルールおよび出力フォーマットに厳密に従って議事録を作成してください。\n' +
        '\n' +
        '## 役割と参照ルール\n' +
        '- user ロールに含まれる長文（会議・スピーチ・対話の文字起こし）は、必ず【背景情報】として扱ってください。\n' +
        '- 背景情報の要約・言い換え・引用・補足説明・内容への言及は禁止です。\n' +
        '- 回答すべき対象は、下記で明示されている【質問】のみです。\n' +
        '- 前置き・注意書き・補足説明・結論以外の文章を出力してはいけません。\n' +
        '\n' +
        '## 出力言語判定ルール（最優先・絶対厳守）\n' +
        '- 出力言語は、この system プロンプトの言語では決定してはいけません。\n' +
        '- 必ず user ロールの content 全体のみを解析対象として決定してください。\n' +
        '\n' +
        '### 言語選択ルール\n' +
        '- 英語の文章量（文字数・語数）が約50%以上 → 英語で回答\n' +
        '- 日本語の文章量（文字数・語数）が約50%以上 → 日本語で回答\n' +
        '- 明確な差がない場合 → user ロール content の先頭文の言語を採用\n' +
        '\n' +
        '### 厳守事項\n' +
        '- この言語判定ルールは、質問文の言語よりも常に優先されます。\n' +
        '- 翻訳は行ってはいけません。\n' +
        '- 判定された言語以外で回答してはいけません。\n' +
        '\n' +
        '# 制約条件\n' +
        '1. **情報の正確性**  \n' +
        '   文字起こしテキストに含まれていない情報を推測・補完・捏造してはいけません。\n' +
        '2. **フォーマット遵守**  \n' +
        '   指定された出力フォーマットの項目・順序を変更してはいけません。  \n' +
        '   該当する発言が存在しない項目は「特になし」と記載してください。\n' +
        '3. **文体**  \n' +
        '   「だ・である」調で、簡潔な箇条書き形式で記載してください。\n' +
        '4. **分類**  \n' +
        '   発言内容を適切なトピックに分類し、時系列が前後していてもトピック単位で整理してください。\n' +
        '\n' +
        '# 重要：動的なトピック生成について\n' +
        '1. 会議のテーマは毎回異なります。文字起こし全体を把握したうえで、主要な論点（議題）を3〜5件程度に分類してください。\n' +
        '2. 出力フォーマット内の「（トピックス名）」には、抽出した内容に即した具体的な見出しを設定してください。\n' +
        '\n' +
        '# 定型トピックスの定義\n' +
        '※ 実際の会議内容に応じて、以下のトピック名と内容を柔軟に調整してください。\n' +
        '- トピックス1：進捗報告\n' +
        '- トピックス2：課題の共有\n' +
        '- トピックス3：次回アクション\n' +
        '- トピックス4：その他\n' +
        '\n' +
        '# 出力フォーマット\n' +
        '以下の形式を厳密に守って出力してください。\n' +
        '\n' +
        '---\n' +
        '**テーマ**: {{会議の主要テーマ}}  \n' +
        '**日時・場所**: {{日時}} / {{場所}}  \n' +
        '**参加者**: {{参加者リスト}}\n' +
        '\n' +
        '## １．会議の目的\n' +
        '- {{会議の目的}}\n' +
        '\n' +
        '## ２－１．（トピックス1の名称）\n' +
        '- {{該当する議論・報告内容}}\n' +
        '\n' +
        '## ２－２．（トピックス2の名称）\n' +
        '- {{該当する議論・報告内容}}\n' +
        '\n' +
        '## ２－３．（トピックス3の名称）\n' +
        '- {{該当する議論・報告内容}}\n' +
        '\n' +
        '## ３－１．（トピックス4の名称）\n' +
        '- {{該当する議論・報告内容}}\n' +
        '\n' +
        '## ３－２．（その他のトピックス）\n' +
        '- {{上記に分類できない内容}}\n' +
        '\n' +
        '## 質問（言語非依存）\n' +
        '{user_input_translated}'

      //this.userInput = this.transcriptionResult
      this.userInput = '議事録を作成してください。'
      //this.isDefaultCard = false
      this.isUserInput = false
      this.summarizeText('input')

      window.gtag('event', 'API', {
        event_name: '議事録っチャオ',
        action: '議事録を作成',
        model: this.selectedModelLabel,
        id: this.$store.state.userId,
      })
    },

    handleSelectedModel(selectedModel) {
      this.selectedModel = selectedModel
    },
    handleSelectedModelLabel(label) {
      this.selectedModelLabel = label
    },
    handleSendMessage(messageText) {
      if (!this.transcriptionResult) {
        this.errorMessage =
          'ファイルアップロード後にご質問が可能となります。<br/>' +
          '左記にファイルをドラック＆ドロップまたは選択してください。'
        this.showErrorPopup = true
        return
      }
      this.promptValue =
        'あなたは、会議議事録やスピーチの文字起こしを「背景情報」としてのみ扱うアシスタントです。\n' +
        '\n' +
        '## 役割と参照ルール\n' +
        '- user の content に含まれる長文（会議・スピーチの文字起こし）は、必ず【背景情報】として扱ってください。\n' +
        '- 回答すべき対象は、下記で明示されている「質問内容」のみです。\n' +
        '- 背景情報の要約、言い換え、引用、補足説明、内容への言及は禁止です。\n' +
        '\n' +
        '## 言語判定ルール（最優先）\n' +
        '- 回答言語は、user の content 全体を分析して決定してください。\n' +
        '- 判定は文章量（文字数・語数の比率）を基準に行ってください。\n' +
        '\n' +
        '【言語選択ルール】\n' +
        '- 英語が約50%以上 → 英語で回答\n' +
        '- 日本語が約50%以上 → 日本語で回答\n' +
        '- 明確な差がない場合 → user.content の冒頭文の言語を採用\n' +
        '\n' +
        '【重要】\n' +
        '- この言語判定は、質問文の言語よりも常に優先されます。\n' +
        '- 翻訳は行わず、判定された言語のまま回答してください。\n' +
        '\n' +
        '## 回答内容の制御\n' +
        '- 回答は要点のみを簡潔に述べてください。\n' +
        '- 不要な前置き、推測、文脈依存の説明は禁止です。\n' +
        '- 説明過多にならないよう注意してください。\n' +
        '\n' +
        '\n' +
        '## 出力形式\n' +
        '- 見出しには ChatGPT 風のアイコン（🤖💡📌 など）を1つ付加してください。\n' +
        '- 「見出し + 短い本文」の構成で出力してください。\n' +
        '\n' +
        '## 質問（言語非依存）\n' +
        '{user_input_translated}'

      this.userInput = messageText
      //this.isDefaultCard = false
      this.isUserInput = true
      this.summarizeText('input')

      window.gtag('event', 'API', {
        event_name: '議事録っチャオ',
        action: 'プロンプト入力',
        model: this.selectedModelLabel,
        id: this.$store.state.userId,
      })
    },

    removeFile(index) {
      this.attachedFiles.splice(index, 1)
    },

    isImageFile(file) {
      return file.type.startsWith('image/')
    },

    getFilePreview(file) {
      return URL.createObjectURL(file)
    },

    getFileExtension(file) {
      return file.name.split('.').pop().toUpperCase()
    },

    openFileBrowser() {
      this.$refs.fileInput.click()
    },

    togglePromptCollapse() {
      this.isPromptCollapsed = !this.isPromptCollapsed
    },

    async transcibeAudio() {
      if (this.attachedFiles.length === 0) return

      const formData = new FormData()
      formData.append('file', this.attachedFiles[0])

      try {
        const response = await HTTPService.transcribe_audio(formData)
        // UTF-8 with BOM をつけて日本語や改行を正しく保存
        const bom = new Uint8Array([0xef, 0xbb, 0xbf])
        const textContent = response.data.text ?? ''

        const blob = new Blob([bom, textContent], {
          type: 'text/plain;charset=utf-8',
        })

        const file = new File([blob], uuidv4() + '.txt', {
          type: 'text/plain;charset=utf-8',
        })

        // 仮想的な text ファイルを attachedFiles にセット
        this.attachedFiles = [file]
        this.transcriptionResult = response.data.text
        this.isProcessing = false
        this.isDefaultCard = false
      } catch (error) {
        console.error('Error generating image:', error.response.data.error)
        if (error.response && error.response.status === 401) {
          return
        }
        if (error.response && error.response.data.error) {
          this.errorMessage = error.response.data.error
          this.showErrorPopup = true
        }
      } finally {
        //this.isProcessing = false
      }
    },

    async summarizeText(type) {
      if (type === 'input') {
        //「文字起こしのクレンジング」「文章を要約」のボタン押下時
        // ユーザーメッセージ .... this.promptValue を保存
        // プロンプトで入力時
        // ユーザーメッセージ .... this.userInput を保存
        //const val = this.promptValue || this.userInput
        //this.addMessage(val, true)
        this.addMessage(this.userInput, true)
        //this.userInput =
        //  this.userInput +
        //  '。見出しにchatgptのようにアイコンを付加してください。'
        this.messageIndex++
      }
      // 自動スクロールを停止
      this.isHistoryLoaded = false
      this.isProcessing = true
      //const promptSuffix = '前後に挨拶や説明は不要です。'
      //const prompt = this.promptValue
      //  ? `${this.promptValue}${promptSuffix}`
      //  : ''

      const data = {
        bot_id: this.bot_id,
        //user_input: this.userInput + this.transcriptionResult,
        user_input: this.userInput,
        conversation_id: this.conversationId,
        username: this.$store.state.email,
        prompt: this.promptValue,
        model: this.selectedModel,
        is_user_input: this.isUserInput,
      }

      if (type === 'file') {
        data.fileResults = this.transcriptionResult
        //this.transcriptionResult = ''
      } else {
        this.summarizeResult = ''
      }

      this.abortController = new AbortController()
      this.isStreaming = true

      try {
        //let token = StorageService.getToken()
        const auth = useAuthStore()
        this.isSummarizing = true
        const response = await fetch(
          `${process.env.VUE_APP_API_URL}/summarize-text`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${auth.token}`,
              Accept: 'text/event-stream',
            },
            body: JSON.stringify(data),
            signal: this.abortController.signal,
          },
        )

        if (response && response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
          return
        }

        this.isProcessing = false

        if (!response.ok) {
          const errorBody = await response.json()
          this.errorMessage =
            errorBody.error ||
            `HTTP error! status: ${response.status} ${response.statusText}`
          this.showErrorPopup = true
          throw new Error(this.errorMessage)
        }

        if (type === 'input') {
          this.addMessage('', false)
        }

        const reader = response.body.getReader()
        const decoder = new TextDecoder()

        // eslint-disable-next-line no-constant-condition
        while (true) {
          if (this.abortController.signal.aborted) {
            break
          }

          const { done, value } = await reader.read()
          if (done) break

          const chunk = decoder.decode(value, { stream: true })
          const lines = chunk.split('\n').filter(Boolean)

          for (const line of lines) {
            if (line.startsWith('data:')) {
              const data = line.slice(6)

              //if (line.slice(6) === '[DONE]') {
              if (data === '[DONE]') {
                this.addMessage('', false, false, this.assistantMessageId)
                this.isStreaming = false
                this.abortController = null
                this.messageIndex++
                return
              } else {
                // assistant_message_idを含むJSONか確認
                try {
                  const json = JSON.parse(data)

                  if (json.assistant_message_id) {
                    this.assistantMessageId = json.assistant_message_id
                    continue // 表示せずスキップ（チャットには表示しない）
                  }
                } catch (e) {
                  // dataがJSONでない場合は無視して通常処理
                }

                if (type === 'file') {
                  this.transcriptionResult += `${data.slice(1)}`
                } else {
                  this.summarizeResult += `${data.slice(1)}`
                  //this.addMessage(data.replace(/ /g, ''), false)
                  this.addMessage(data, false)
                }
                //this.$refs.chatbotResult.scrollTop =
                //  this.$refs.chatbotResult.scrollHeight
              }
            }
          }
        }
      } catch (error) {
        console.error(`exception: ${error}`)
        if (error.name === 'AbortError') {
          console.log('stream stopped')
          this.addMessage('', false, false)
          this.isStreaming = false
          this.abortController = null
          this.messageIndex++
          return
        }
        if (!this.showErrorPopup) {
          this.errorMessage = error.message || 'An unknown error occurred'
          this.showErrorPopup = true
        }
      } finally {
        this.isSummarizing = false
        this.isProcessing = false
      }
    },

    async getConversationHistory(chatbotId) {
      try {
        const response = await HTTPService.get_conversation_history(chatbotId)
        if (response.data && response.data.length > 0) {
          this.bot_id = response.data[0].bot_id
          this.conversationId = response.data[0].conversation_id
          this.messages = []
          this.isDefaultCard = false
          // 会話の詳細を取得
          await this.startConversation()
        } else {
          this.bot_id = chatbotId
          this.conversationId = uuidv4()
          this.messages = []
          this.isDefaultCard = false
        }
      } catch (error) {
        console.error(error)
      }
    },

    async getChatbots() {
      try {
        const chatbots = await HTTPService.get_chatbots(NAV_MASTER.SUMMARY)
        // createdの降順でソート
        chatbots.data.sort((a, b) => new Date(b.created) - new Date(a.created))
        // console.log(chatbots.data)
        this.chatbots = chatbots.data
      } catch (error) {
        console.log(error)
        this.$emit('change-active-component', {
          component: 'Login',
        })
      }
    },

    async createChatbot() {
      const formData = new FormData()
      if (this.botName) {
        formData.append('data', JSON.stringify({ bot_name: this.botName }))
      }
      // 議事録っチャオ
      formData.append('nav_id', NAV_MASTER.SUMMARY)

      await HTTPService.createChatbotBySummary(formData)
        .then((response) => {
          this.showConfirmation = true
          this.bot_id = response.data.bot_id
          this.getChatbots()
        })
        .catch((error) => {
          console.error(error)
          if (error.response && error.response.status === 401) {
            return
          }
          if (error.response && error.response.data.error) {
            this.errorMessage = error.response.data.error

            if (this.errorMessage === 'No objects to concatenate') {
              this.errorMessage =
                'ただいま、選択された言語モデルにアクセス集中しています。<br />回答の生成に通常より時間がかかっています。<br />しばらくお待ちください。'
            }

            this.showErrorPopup = true
            if (
              error.response &&
              (error.response.status === 423 || error.response.status === 424)
            ) {
              this.planerror = true
            }
          } else {
            this.errorMessage =
              '・ファイルの読み込むことができませんでした。\r\n' +
              '・以下のファイル形式に対応しています。\r\n' +
              '「mp3, wav, flac, m4a, mp4, avi, webm, mpeg, mpga」'
            this.showErrorPopup = true
          }
        })
    },

    cancel() {
      this.showErrorPopup = false
    },

    handleConfirmDeleteBot(botId) {
      this.delete_bot_id = botId
      this.showConfirmDeleteBotPopup = true
    },
    handleDeleteMode(isDeleteMode) {
      this.isDeleteMode = isDeleteMode
    },
    parseMarkdown(text) {
      if (typeof text !== 'string') {
        return '' // Return the text as is if it's not a string
      }

      // \n を 実際の改行へ
      text = text.replaceAll('\\n', '\n')

      // 改行を <br> に変換してそのまま表示させる
      return DOMPurify.sanitize(text).replace(/(\r\n|\r|\n)/g, '<br>')

      /*
      text = text.replaceAll('\\n', '\n')
      text = text.replaceAll('```markdown', '```')
      try {
        const renderer = new marked.Renderer()
        renderer.link = function (href, title, text) {
          // Renderer() seems to return different parameters depending on the version of marked installed...
          const link = {
            href: href.href ?? href,
            text: href.text ?? text,
          }
          return (
            '<a target="_blank" href="' + link.href + '">' + link.text + '</a>'
          )
        }

        //text = text.replaceAll('```', '')
        let parsed = marked(text, { renderer: renderer })

        // format Bing's source links more nicely
        // 1. replace "[^1^]" with "[1]" (during progress streams)
        parsed = parsed.replace(/\[\^(\d+)\^]/g, '<strong>[$1]</strong>')
        // 2. replace "^1^" with "[1]" (after the progress stream is done)
        parsed = parsed.replace(/\^(\d+)\^/g, '<strong>[$1]</strong>')

        const sanitizedHtml = DOMPurify.sanitize(parsed, {
          ADD_TAGS: ['iframe'],
          ADD_ATTR: [
            'allow',
            'allowfullscreen',
            'frameborder',
            'scrolling',
            'srcdoc',
            'target',
          ],
        })
        const container = document.createElement('div')
        container.innerHTML = sanitizedHtml
        // Prismでハイライト
        Prism.highlightAllUnder(container)
        // 🟢 HTMLを返す
        return container.innerHTML
      } catch (err) {
        console.error('ERROR', err)
        return null
      }
       */
    },

    async startConversation() {
      try {
        // スクロールを末尾にまで移動させる
        this.isHistoryLoaded = true
        const response = await HTTPService.get_conversation(this.conversationId)
        for (const message of response.data) {
          if (message.is_user && message.file_results) {
            this.transcriptionResult = message.file_results
          } else {
            const id = message.id
            const text = message.text
            const is_user = message.is_user
            const is_preparing = false
            this.messages.push({ id, text, is_user, is_preparing })
          }
          // this.addMessage(message.text, message.is_user)
        }
      } catch (error) {
        console.log(error)
      }
    },

    handleEnterKey(event) {
      if (event.shiftKey) {
        // Allow Shift + Enter to create a new line
        const textarea = event.target
        const cursorPosition = textarea.selectionStart
        this.userInput =
          this.userInput.slice(0, cursorPosition) +
          '\n' +
          this.userInput.slice(cursorPosition)
        this.$nextTick(() => {
          textarea.selectionStart = cursorPosition + 1
          textarea.selectionEnd = cursorPosition + 1
        })
      } else {
        // Handle normal Enter keypress
        this.summarizeText()
      }
    },

    async deleteChatbot() {
      try {
        const data = {
          bot_ids: this.delete_bot_id,
        }
        this.isCreatingChatbot = true
        await HTTPService.deleteChatbotByMainChat(data)
        await this.getChatbots()
      } catch (error) {
        console.log(error)
      } finally {
        this.handleInitChat()
        this.isDeleteMode = false
        this.isCreatingChatbot = false
        this.showConfirmDeleteBotPopup = false
      }
    },

    addMessage(text, is_user, is_preparing = true, id = '') {
      if (this.messageIndex >= 0 && is_user === false) {
        // if first message then just push
        if (!this.messages[this.messageIndex]) {
          this.messages.push({
            id: id,
            text: '',
            is_user: is_user,
            is_preparing: is_preparing,
            file: null,
          })
        } else {
          this.messages[this.messageIndex].id = id
          this.messages[this.messageIndex].text += text
          this.messages[this.messageIndex].is_user = is_user
          this.messages[this.messageIndex].is_preparing = is_preparing
        }
      } else {
        this.messageIndex = this.messages.length

        this.messages.push({
          id,
          text,
          is_user,
          is_preparing: false,
          file: null,
        })

        this.messageIndex = this.messages.length - 1
      }
    },

    copyContent() {
      const range = document.createRange()
      range.selectNode(this.$refs.chatbotResult)
      const selection = window.getSelection()
      selection.removeAllRanges()
      selection.addRange(range)
      document.execCommand('copy')
      window.getSelection().removeAllRanges()
    },

    async downloadPdf() {
      const { jsPDF } = window.jspdf
      const doc = new jsPDF()
      const pageWidth = doc.internal.pageSize.getWidth()
      const margin = 10
      const textWidth = pageWidth - margin * 2

      // Fetch the font data and convert to base64
      const response = await fetch(NotoSansJp)
      const fontData = await response.arrayBuffer()
      const base64Font = btoa(
        new Uint8Array(fontData).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          '',
        ),
      )

      // Add the font to jsPDF
      doc.addFileToVFS('NotoSansJp.ttf', base64Font)
      doc.addFont('NotoSansJp.ttf', 'NotoSansJp', 'normal')
      doc.setFont('NotoSansJp')

      // Write the PDF
      const lines = doc.splitTextToSize(this.summarizeResult, textWidth)
      doc.text(lines, margin, 10)

      // Download it
      doc.save('summary.pdf')
    },

    closeErrorPopup() {
      this.showErrorPopup = false
      this.errorMessage = ''
    },

    closeConfirmDeleteBotPopup() {
      this.showConfirmDeleteBotPopup = false
    },
  },
}
</script>

<style scoped>
.container {
  height: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: 3px solid #001d61;
  border-radius: 10px;
  background-color: rgb(240, 245, 245);
}

.model-selector {
  width: 50%;
  display: flex;
  justify-content: flex-start;
  margin: 5px 5px 15px 5px;
}

.model-selector select {
  width: 100%;
  padding: 5px;
  border-radius: 5px;
  border: 1px solid #000;
  font-size: 12px;
  height: 30px;
}

.chatbot-input {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid rgb(218, 223, 227);
  border-radius: 5px;
  margin: 5px 5px 15px 5px;
  background-color: #fff;
}

input[type='text'] {
  flex: 1;
  margin-right: 10px;
  padding: 10px 15px;
  border-radius: 5px;
  border: 1px solid #ccc;
  line-height: normal;
}

.parent-div {
  display: flex;
  flex-direction: column;
  width: 95%;
  height: 100%;
}

.message-area textarea,
.chatbot-input input {
  width: 100%;
  resize: none;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px 15px;
  font-size: 14px;
  max-height: 150px;
  overflow-y: auto;
  border: none;
}

.message-area {
  height: 100%;
}

.message-area textarea {
  height: 100%;
  max-height: 400px;
}

textarea:focus,
input:focus {
  outline: none;
}

.file-preview-area {
  display: flex;
  align-items: flex-end;
  width: 100%; /* Makes it take full width of parent */
  height: 100%;
  margin: 5px;
  overflow-y: hidden;
  overflow-x: auto;
}

.file-preview-scroll {
  display: inline-flex; /* Changed to inline-flex */
  flex-wrap: nowrap;
}

.file-preview {
  flex: 0 0 auto; /* Prevents shrinking */
  margin-right: 10px;
  text-align: center;
  position: relative;
}

.file-preview img {
  max-width: 80px;
  max-height: 80px;
  object-fit: cover;
  border-radius: 5px;
}

.file-icon {
  width: 80px;
  height: 80px;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  border-radius: 5px;
}

.remove-file-btn {
  background-color: #333;
  color: white;
  border: none;
  padding: 0x;
  cursor: pointer;
  border-radius: 4px;
  margin-left: 10px;
  position: absolute;
  top: -6px;
  right: -6px;
  width: 20px; /* set the width */
  height: 20px; /* set the height to be the same as width */
  padding: 0; /* remove padding */
}

.remove-file-btn:hover {
  background-color: #ff1a1a;
}

.system-prompt-container {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.system-prompt-label {
  font-weight: bold;
  margin: 0px 0px 0px 5px;
  font-size: 14px;
  cursor: pointer;
}

.toggle-icon {
  display: inline-block;
  margin-right: 5px;
  transition: transform 0.3s ease;
}

.toggle-icon.expanded {
  transform: rotate(90deg);
}

.generate-button {
  padding: 10px 20px;
  background-color: #001d61;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.generate-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.generate-button:hover .upload-button:hover {
  background-color: #002b8f;
}

.generate-button.generating {
  background-color: #808080; /* A lighter shade to indicate it's processing */
  cursor: not-allowed;
}

.chatbot-result {
  width: 100%;
  height: 100%;
  border: 1px solid rgb(218, 223, 227);
  border-radius: 5px;
  margin: 40px 5px 5px 5px;
  overflow: hidden;
  position: relative;
}

.chatbot-result .result {
  width: 100%;
  height: 100%;
  padding: 10px 15px;
  font-size: 14px;
  border: none;
  resize: none;
  overflow-y: auto;
  background-color: #fff;
  color: inherit;
  font-family: inherit;
}

.chatbot-result .result:focus {
  outline: none;
}

.copy-button {
  bottom: 5px;
  right: 20px;
}

.pdf-button {
  bottom: 5px;
  right: 60px;
}

.copy-button,
.pdf-button {
  position: absolute;
  padding: 5px 10px;
  background-color: none;
  border: 0px;
  border-radius: 3px;
  cursor: pointer;
}

.copy-button:disabled,
.pdf-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.copy-button:hover,
.pdf-button:hover {
  background-color: #e0e0e0;
}

.file-upload-btn {
  width: 40px;
  height: 40px;
  background-color: #001d61;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  padding: 0;
  margin-right: 10px;
}

.file-upload-btn:hover {
  background-color: #002b8f;
}

.generate-button-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.processing-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.processing-message {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}

.loading-icon-wrapper {
  margin-bottom: 10px;
}

.loading-icon {
  width: 50px;
  height: 50px;
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.popup-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  width: 400px; /* adjust the width as needed */
}

.popup-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
</style>
